import styled from "styled-components";
import { mediaMax } from "../../../../styles/mediaQueries";

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  ${mediaMax.tabletLandscape`
    flex-direction: column;
  `};
`;

export const Nav = styled.div`
  width: 300px;
  padding: 0;
  ${mediaMax.tabletLandscape`
    width:60%;
  `};
  ${mediaMax.tablet`
    width:100%;
  `};

  h3 {
    font-family: "SangBleu Kingdom",sans-serif;
    font-size: 21px;
    line-height: 28px;
    margin: 0 0 8px 0;
    padding-top: 4px;
  }
`;

export const Map = styled.div`
  width: calc(95% - 340px);
  ${mediaMax.tabletLandscape`
    width: 100%;
    height: auto;
    margin-top: 60px;
  `};
  ${mediaMax.phoneXL`
    width: 100%;
    height: 50vh;
    margin-top: 0;
    margin-bottom: 24px;
  `};

  img {
    width: 100%;
  }
`;
